import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import history from 'config/history';

import { VerificationStatus } from 'graphql/generated/graphql';

import ReduxState from 'store/ReduxState';

import { usePlayer } from './usePlayer';

enum AVSRedirect {
  Hardcore = 'hardcore',
  VerifyPin = 'verify-pin',
}

const useHandleAVSRedirect = (femtasyRed: boolean, onClick?: () => void) => {
  const { isVerifiedUser, userWithVerifiedPin } = useSelector<
    ReduxState,
    { isVerifiedUser: boolean; userWithVerifiedPin: boolean }
  >(({ profile }) => {
    return {
      isVerifiedUser:
        profile?.user?.verificationStatus === VerificationStatus.Success,
      userWithVerifiedPin: profile?.isVerified,
    };
  });

  const { togglePlay, isPlaying } = usePlayer();

  const userIsInAVSFlow =
    femtasyRed && (!isVerifiedUser || !userWithVerifiedPin);

  const handleAVSRedirect = useCallback(() => {
    const notVerified = femtasyRed && !isVerifiedUser;
    const notVerifiedPin = femtasyRed && !userWithVerifiedPin;

    const pausePlayback = () => isPlaying && togglePlay();

    switch (true) {
      case notVerified:
        pausePlayback();
        history.push(`${window.location.pathname}/${AVSRedirect.Hardcore}`);
        break;

      case notVerifiedPin:
        pausePlayback();
        history.push(`${window.location.pathname}/${AVSRedirect.VerifyPin}`);
        break;

      default:
        onClick && onClick();
        return;
    }
  }, [
    togglePlay,
    isPlaying,
    femtasyRed,
    isVerifiedUser,
    userWithVerifiedPin,
    onClick,
  ]);

  return { handleAVSRedirect, userIsInAVSFlow };
};

export default useHandleAVSRedirect;
